export default function Services() {
  const services = [
    {
      icon: 'ri-brush-line',
      title: 'Deep Cleaning',
      description: 'Thorough top-to-bottom cleaning for a spotless home',
      features: [
        'All rooms deep cleaned',
        'Kitchen appliances & cabinets',
        'Bathroom sanitization',
        'Baseboards & window sills'
      ],
      price: 120,
      popular: false
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Regular Cleaning',
      description: 'Weekly or bi-weekly maintenance to keep your home fresh',
      features: [
        'Dusting all surfaces',
        'Vacuum & mop floors',
        'Kitchen & bathroom cleaning',
        'Trash removal'
      ],
      price: 75,
      popular: true
    },
    {
      icon: 'ri-truck-line',
      title: 'Move-in/Move-out',
      description: 'Complete cleaning for moving transitions',
      features: [
        'Empty property cleaning',
        'Inside cabinets & drawers',
        'Appliance deep clean',
        'Wall spot cleaning'
      ],
      price: 180,
      popular: false
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wide">Our Services</span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3">
            Everything Your Home Needs
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`bg-white rounded-3xl p-8 hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-2xl relative ${
                service.popular ? 'md:-translate-y-4' : ''
              }`}
            >
              {service.popular && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-teal-600 text-white px-6 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                  Most Popular
                </div>
              )}
              
              <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6">
                <i className={`${service.icon} text-4xl text-white`}></i>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-6">{service.description}</p>

              <ul className="space-y-3 mb-8">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-gray-700">
                    <i className="ri-check-line text-teal-600 text-xl flex-shrink-0"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <div className="mb-6">
                <div className="text-4xl font-bold text-teal-600">
                  ${service.price}
                </div>
                <p className="text-gray-500 text-sm">Starting price</p>
              </div>

              <button className="w-full border-2 border-teal-600 text-teal-600 py-3 rounded-lg font-semibold hover:bg-teal-600 hover:text-white transition-all whitespace-nowrap cursor-pointer">
                Select Service
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
